/* eslint-disable */
import { css } from 'styled-components';
import { generateMedia } from 'styled-media-query';

import breakpoints from './breakpoints';

/**
 * Convert our breakpoints into the format styled-media-query expects and then
 * create the a custom set of media generators.
 *
 * How to use:
 * - lessThan('medium)``
 * - greaterThan('medium')``
 * - between('medium', 'large')``
 * - greaterThan('123px')``
 */
const customBreakpoints = {};
for (let breakpointName in breakpoints) {
  const value = breakpoints[breakpointName];

  if (value !== Infinity) {
    customBreakpoints[breakpointName] = value + 1 + 'px';
  }
}
const breakpointMediaGenerators = generateMedia(customBreakpoints);

/**
 * Media templates for portrait and landscape orientations.
 *
 * How to use:
 * - orientation('portrait')``
 * - orientation('landscape)``
 */
const orientationMediaGenerators = {
  orientation: (orientation) => (...args) => css`
    @media screen and (orientation: ${orientation}) {
      ${css(...args)}
    }
  `
};

/**
 * Sometimes you might have the urge to nest media generators inside of eachother.
 * IE11 does not support nested media queries
 *
 * How to use:
 * - orientationBreakpointGreaterThan('landscape', 'medium')``
 * - orientationBreakpointGreaterThan('portrait', 'large')``
 */
const combinedMediaGenerators = {
  orientationBreakpointGreaterThan: (orientation, breakpoint) => (...args) => css`
    @media screen and (orientation: ${orientation}) and (min-width: ${breakpoints[breakpoint] + 1}px) {
      ${css(...args)}
    }
  `
};

/**
 * All the various types of media generators get combined on to a single media object.
 *
 * How to use:
 * - media.greaterThan('medium')`
 * - media.orientation('portrait')`
 * - media.orientationBreakpointGreaterThan('portrait', 'medium')`
 */
const media = Object.assign(breakpointMediaGenerators, orientationMediaGenerators, combinedMediaGenerators);

export default media;
/* eslint-enable */



/** WEBPACK FOOTER **
 ** ./src/css/media.js
 **/